import { UniStorage } from './storage/UniStorage';

const lastUserName = 'LastUserName';

/*
 * This class is meant to save the data that is NOT user-specific, e.g. should be available even if no user is logged in (e.g. LastUserName).
 * If the data is user-specific, consider storing it in Redux (and it will be persisted via redux-persist)
 */
export class WebStorage implements UniStorage {
  private _backendUri: string;

  constructor(backendUri: string) {
    this._backendUri = backendUri;
  }

  public get BackendUri(): string {
    return this._backendUri;
  }

  public set BackendUri(uri: string) {
    this._backendUri = uri;
  }

  public get LastUserName(): string | undefined {
    return this.getItem<string>(lastUserName);
  }

  public set LastUserName(login: string | undefined) {
    this.setItem(lastUserName, login);
  }

  getItem<T>(path: string): T | undefined {
    const data = window.localStorage.getItem(path);
    if (data) {
      try {
        return JSON.parse(data) as T;
      } catch (err) {
        console.error('webStorage.getItem', err);
      }
    }
    return undefined;
  }

  setItem<T>(path: string, value: T) {
    if (value) {
      window.localStorage.setItem(path, JSON.stringify(value));
    } else {
      window.localStorage.removeItem(path);
    }
  }
}
